import { CommonStrings } from "../../../../../common/classes/CommonStrings";
import { SMSRouteDefs } from "../../../routing/SMSRouteDefs";
import { IBLRouteDefs } from "./IBLRouteDefs";

export class IBLWirkungsmessungRouteDefs {
  public static FEATURE_PATH = "ibl-wirkungsmessung";
  public static PARAM_ID = "Id";
  public static FKT_LIST_PATH = `home`;

  public static BASE_PATH = `${SMSRouteDefs.FEATURE_PATH}/${IBLRouteDefs.FEATURE_PATH}/${this.FEATURE_PATH}`;

  public static LIST_PATH = `${CommonStrings.KW_LIST}`;
  public static LIST_FQ_PATH = `${SMSRouteDefs.FEATURE_PATH}/${IBLRouteDefs.FEATURE_PATH}/${this.FEATURE_PATH}/${this.LIST_PATH}`;
  public static CREATE_PATH = `${CommonStrings.KW_CREATE}`;
  public static CREATE_FQ_PATH = `${SMSRouteDefs.FEATURE_PATH}/${IBLRouteDefs.FEATURE_PATH}/${this.FEATURE_PATH}/${this.CREATE_PATH}`;
  public static UPDATE_PATH = `:${this.PARAM_ID}`;
  public static UPDATE_FQ_PATH = `${SMSRouteDefs.FEATURE_PATH}/${IBLRouteDefs.FEATURE_PATH}/${IBLRouteDefs.FEATURE_PATH}/${this.FEATURE_PATH}/${this.UPDATE_PATH}`;
  public static FKT_LIST_FQ_PATH = `${SMSRouteDefs.FEATURE_PATH}/${IBLRouteDefs.FEATURE_PATH}/${this.FEATURE_PATH}/${this.FKT_LIST_PATH}`;
  public static FQ_PATH = `${SMSRouteDefs.FEATURE_PATH}/${IBLRouteDefs.FEATURE_PATH}/${this.FEATURE_PATH}`;
  // Neue Routedefs für Dachverbandsabfrage und LAP/AP-Ablegungsauswertungen
  public static DV_ABFRAGE_ERSTE_LIST_PATH = `dvabfrage-erste-list`;
  public static DV_ABFRAGE_ERSTE_LIST_FQ_PATH = `${SMSRouteDefs.FEATURE_PATH}/${IBLRouteDefs.FEATURE_PATH}/${this.FEATURE_PATH}/${this.DV_ABFRAGE_ERSTE_LIST_PATH}`;
  public static DV_ABFRAGE_ERSTE_CREATE_PATH = `dvabfrage-erste-create`;
  public static DV_ABFRAGE_WEITERE_CREATE_PATH = `dvabfrage-weitere-create`;
  public static DV_ABFRAGE_KORRIGIEREN_LIST_PATH = `dvabfrage-korrigieren-list`;
  public static DV_ABFRAGE_ABZEICHNEN_LIST_PATH = `dvabfrage-abzeichnen`;
  public static DV_ABFRAGE_ABZEICHNEN_PATH = `dvabfrage-abzeichnen/:${this.PARAM_ID}`;
  public static DV_ABFRAGE_KORRIGIEREN_PATH = `dvabfrage-korrigieren/:${this.PARAM_ID}`;
  public static DV_ABFRAGE_FREIGEBEN_PATH = `dvabfrage-freigeben/:${this.PARAM_ID}`;
  public static DV_ABFRAGE_FREIGEBEN_LIST_PATH = `dvabfrage-freigeben`;
  public static DV_ABFRAGE_ANZEIGEN_PATH = `dvabfrage-anzeigen`;
  public static DV_ABFRAGE_AUSWERTUNGEN_PATH = `dvabfrage-auswertungen`;
  public static LAPAP_ABLEGUNG_AUSWERTUNGEN_PATH = `lapap-ablegung-auswertungen`;
  public static DV_ABFRAGE_ERSTE_CREATE_FQ_PATH = `${SMSRouteDefs.FEATURE_PATH}/${IBLRouteDefs.FEATURE_PATH}/${this.FEATURE_PATH}/${this.DV_ABFRAGE_ERSTE_CREATE_PATH}`;
  public static DV_ABFRAGE_ERSTE_CREATE_PERSON_PATH = `${this.DV_ABFRAGE_ERSTE_CREATE_PATH}/:${this.PARAM_ID}`;
  public static DV_ABFRAGE_ERSTE_CREATE_PERSON_FQ_PATH = `${SMSRouteDefs.FEATURE_PATH}/${IBLRouteDefs.FEATURE_PATH}/${this.FEATURE_PATH}/${this.DV_ABFRAGE_ERSTE_CREATE_PERSON_PATH}`;
  public static DV_ABFRAGE_WEITERE_LIST_PATH = `dvabfrage-weitere-list`;
  public static DV_ABFRAGE_WEITERE_LIST_FQ_PATH = `${SMSRouteDefs.FEATURE_PATH}/${IBLRouteDefs.FEATURE_PATH}/${this.FEATURE_PATH}/${this.DV_ABFRAGE_WEITERE_LIST_PATH}`;
  public static DV_ABFRAGE_WEITERE_CREATE_FQ_PATH = `${SMSRouteDefs.FEATURE_PATH}/${IBLRouteDefs.FEATURE_PATH}/${this.FEATURE_PATH}/${this.DV_ABFRAGE_WEITERE_CREATE_PATH}`;
  public static DV_ABFRAGE_WEITERE_CREATE_PERSON_PATH = `${this.DV_ABFRAGE_WEITERE_CREATE_PATH}/:${this.PARAM_ID}`;
  public static DV_ABFRAGE_WEITERE_CREATE_PERSON_FQ_PATH = `${SMSRouteDefs.FEATURE_PATH}/${IBLRouteDefs.FEATURE_PATH}/${this.FEATURE_PATH}/${this.DV_ABFRAGE_WEITERE_CREATE_PERSON_PATH}`;
  public static DV_ABFRAGE_ABZEICHNEN_FQ_PATH = `${SMSRouteDefs.FEATURE_PATH}/${IBLRouteDefs.FEATURE_PATH}/${this.FEATURE_PATH}/${this.DV_ABFRAGE_ABZEICHNEN_PATH}`;
  public static DV_ABFRAGE_KORRIGIEREN_FQ_PATH = `${SMSRouteDefs.FEATURE_PATH}/${IBLRouteDefs.FEATURE_PATH}/${this.FEATURE_PATH}/${this.DV_ABFRAGE_KORRIGIEREN_PATH}`;
  public static DV_ABFRAGE_FREIGEBEN_FQ_PATH = `${SMSRouteDefs.FEATURE_PATH}/${IBLRouteDefs.FEATURE_PATH}/${this.FEATURE_PATH}/${this.DV_ABFRAGE_FREIGEBEN_PATH}`;
  public static DV_ABFRAGE_ANZEIGEN_FQ_PATH = `${SMSRouteDefs.FEATURE_PATH}/${IBLRouteDefs.FEATURE_PATH}/${this.FEATURE_PATH}/${this.DV_ABFRAGE_ANZEIGEN_PATH}`;
  public static DV_ABFRAGE_AUSWERTUNGEN_FQ_PATH = `${SMSRouteDefs.FEATURE_PATH}/${IBLRouteDefs.FEATURE_PATH}/${this.FEATURE_PATH}/${this.DV_ABFRAGE_AUSWERTUNGEN_PATH}`;
  public static LAPAP_ABLEGUNG_AUSWERTUNGEN_FQ_PATH = `${SMSRouteDefs.FEATURE_PATH}/${IBLRouteDefs.FEATURE_PATH}/${this.FEATURE_PATH}/${this.LAPAP_ABLEGUNG_AUSWERTUNGEN_PATH}`;
  public static DV_ABFRAGE_ABZEICHNEN_LIST_FQ_PATH = `${SMSRouteDefs.FEATURE_PATH}/${IBLRouteDefs.FEATURE_PATH}/${this.FEATURE_PATH}/${this.DV_ABFRAGE_ABZEICHNEN_LIST_PATH}`;
  public static DV_ABFRAGE_FREIGABE_LIST_FQ_PATH = `${SMSRouteDefs.FEATURE_PATH}/${IBLRouteDefs.FEATURE_PATH}/${this.FEATURE_PATH}/${this.DV_ABFRAGE_FREIGEBEN_LIST_PATH}`;
  public static FRISTERSTRECKUNG_CREATE_PATH = `fristerstreckung-create`;
  public static FRISTERSTRECKUNG_LIST_PATH = `fristerstreckung-list`;
  public static FRISTERSTRECKUNG_CREATE_FQ_PATH = `${SMSRouteDefs.FEATURE_PATH}/${IBLRouteDefs.FEATURE_PATH}/${this.FEATURE_PATH}/${this.FRISTERSTRECKUNG_CREATE_PATH}`;
  public static FRISTERSTRECKUNG_LIST_FQ_PATH = `${SMSRouteDefs.FEATURE_PATH}/${IBLRouteDefs.FEATURE_PATH}/${this.FEATURE_PATH}/${this.FRISTERSTRECKUNG_LIST_PATH}`;
  public static FRISTERSTRECKUNG_KORREKTUR_PATH = `fristerstreckung-korrektur/:${this.PARAM_ID}`;
  public static FRISTERSTRECKUNG_KORREKTUR_FQ_PATH = `${SMSRouteDefs.FEATURE_PATH}/${IBLRouteDefs.FEATURE_PATH}/${this.FEATURE_PATH}/fristerstreckung-korrektur/:${this.PARAM_ID}`;
  public static REPORT_DV_ABFRAGE_PATH = `report-dv-abfrage/:year/:abfrage/:integrativerBetrieb`;
  public static REPORT_DV_AUSWERTUNG_PATH = `report-dv-abfrage/:year/:integrativerBetrieb/:tnStatus/:auswertung`;
  public static REPORT_LAPAP_ABLEGUNG_PATH = `report-lap-ablegung/:year/:integrativerBetrieb`;
  public static AUFROLLUNG_LIST_PATH = `aufrollung`;
  public static AUFROLLUNG_PATH = `aufrollung/:${this.PARAM_ID}`;
  public static VERSIONEN_PATH = `:versionEntityId/versionen`;
  public static VERSIONEN_FQ_PATH = `${SMSRouteDefs.FEATURE_PATH}/${IBLRouteDefs.FEATURE_PATH}/${this.FEATURE_PATH}/${this.VERSIONEN_PATH}`;
  public static LATEST_VERSIONEN_PATH = `latest-versionen`;
  public static LATEST_VERSIONEN_FQ_PATH = `${SMSRouteDefs.FEATURE_PATH}/${IBLRouteDefs.FEATURE_PATH}/${this.FEATURE_PATH}/${this.LATEST_VERSIONEN_PATH}`;

  public static getDVAbfrageErsteList = () => this.DV_ABFRAGE_ERSTE_LIST_FQ_PATH;

  public static getFQRList = () => this.LIST_FQ_PATH;

  public static getFQRCreate = () => this.CREATE_FQ_PATH;

  public static getFQRUpdate = (id: string) => this.UPDATE_FQ_PATH.replaceAll(this.UPDATE_PATH, id);

  public static getFQRFKTList = () => this.FKT_LIST_FQ_PATH;

  public static getFQR = () => this.FQ_PATH;

  public static getDVAbfrageErsteCreate = () => this.DV_ABFRAGE_ERSTE_CREATE_FQ_PATH;

  public static getDVAbfrageErsteCreatePerson = (id: string) =>
    this.DV_ABFRAGE_ERSTE_CREATE_PERSON_FQ_PATH.replaceAll(`:${this.PARAM_ID}`, id);

  public static getDVAbfrageWeitereList = () => this.DV_ABFRAGE_WEITERE_LIST_FQ_PATH;

  public static getDVAbfrageWeitereCreate = () => this.DV_ABFRAGE_WEITERE_CREATE_FQ_PATH;

  public static getDVAbfrageWeitereCreatePerson = (id: string) =>
    this.DV_ABFRAGE_WEITERE_CREATE_PERSON_FQ_PATH.replaceAll(`:${this.PARAM_ID}`, id);

  public static getDVAbfrageAbzeichnen = (id: string) =>
    this.DV_ABFRAGE_ABZEICHNEN_FQ_PATH.replaceAll(`:${this.PARAM_ID}`, id);

  public static getDVAbfrageAbzeichnenList = () => this.DV_ABFRAGE_ABZEICHNEN_LIST_FQ_PATH;

  public static getDVAbfrageKorrigieren = (id: string) =>
    `${SMSRouteDefs.FEATURE_PATH}/${IBLRouteDefs.FEATURE_PATH}/${this.FEATURE_PATH}/dvabfrage-korrigieren/${id}`;

  public static getDVAbfrageKorrigierenList = () =>
    `${SMSRouteDefs.FEATURE_PATH}/${IBLRouteDefs.FEATURE_PATH}/${this.FEATURE_PATH}/${this.DV_ABFRAGE_KORRIGIEREN_LIST_PATH}`;

  public static getDVAbfrageFreigeben = (id: string) =>
    this.DV_ABFRAGE_FREIGEBEN_FQ_PATH.replaceAll(`:${this.PARAM_ID}`, id);

  public static getDVAbfrageFreigebenList = () => this.DV_ABFRAGE_FREIGABE_LIST_FQ_PATH;

  public static getDVAbfrageAnzeigen = () => this.DV_ABFRAGE_ANZEIGEN_FQ_PATH;

  public static getDVAbfrageAuswertungen = () => this.DV_ABFRAGE_AUSWERTUNGEN_FQ_PATH;

  public static getLAPAPAblegungAuswertungen = () => this.LAPAP_ABLEGUNG_AUSWERTUNGEN_FQ_PATH;

  public static getFQRDVAbfrageReport = (year: string, abfrage: string, integrativerBetrieb: string) =>
    `${SMSRouteDefs.FEATURE_PATH}/${IBLRouteDefs.FEATURE_PATH}/${this.FEATURE_PATH}/${this.REPORT_DV_ABFRAGE_PATH}`
      .replace(":year", year)
      .replace(":abfrage", abfrage)
      .replace(":integrativerBetrieb", integrativerBetrieb);

  public static getVersionen = (versionEntityId: string) =>
    this.VERSIONEN_FQ_PATH.replaceAll(":versionEntityId", versionEntityId);

  public static getLatestVersionen = () => this.LATEST_VERSIONEN_FQ_PATH;

  public static getFQRDVAbfrageAuswertungWithParams = (
    year: string,
    integrativerBetrieb: string,
    tnStatus: string = "",
    auswertung: string = "",
  ) =>
    `${SMSRouteDefs.FEATURE_PATH}/${IBLRouteDefs.FEATURE_PATH}/${this.FEATURE_PATH}/${this.REPORT_DV_AUSWERTUNG_PATH}`
      .replace(":year", year)
      .replace(":integrativerBetrieb", integrativerBetrieb)
      .replace(":tnStatus", tnStatus)
      .replace(":auswertung", auswertung);

  public static getFQRLapAblegungReport = (year: string, integrativerBetrieb: string) =>
    `${SMSRouteDefs.FEATURE_PATH}/${IBLRouteDefs.FEATURE_PATH}/${this.FEATURE_PATH}/${this.REPORT_LAPAP_ABLEGUNG_PATH}`
      .replace(":year", year)
      .replace(":integrativerBetrieb", integrativerBetrieb);

  public static getFristerstreckungCreate = () => this.FRISTERSTRECKUNG_CREATE_FQ_PATH;

  public static getFristerstreckungList = () => this.FRISTERSTRECKUNG_LIST_FQ_PATH;

  public static getFristerstreckungKorrektur = (id: string) =>
    this.FRISTERSTRECKUNG_KORREKTUR_FQ_PATH.replace(`:${this.PARAM_ID}`, id);

  public static getAufrollungList = () => `${this.BASE_PATH}/aufrollung`;

  public static getAufrollung = (personId: string) => `${this.BASE_PATH}/aufrollung/${personId}`;
}
